<section class="modal-panel-secondary__header">
  <h2>Filter</h2>

  <button mat-icon-button (click)="close()">
    <mat-icon fontIcon="close"></mat-icon>
  </button>
</section>

<mat-divider />

<mat-dialog-content class="modal-panel-secondary__content">
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>Processor</mat-label>
      <mat-select formControlName="ProcessorId">
        @for (item of processors; track $index) {
        <mat-option [value]="item.id">
          {{ item.displayName }}
        </mat-option>
        }
      </mat-select>
      @if (showProcessorsClearIcon) {
      <button matSuffix mat-icon-button (click)="resetFilter('ProcessorId')">
        <mat-icon fontIcon="close"></mat-icon>
      </button>
      }
    </mat-form-field>
    <dynamic-autocomplete
        formControlName="FileName"
        [formLabel]="'File Name'"
        [tableName]="'CommissionReconciliationFiles'"
        [columnName]="'FileName'"
        [emitString]="true"
        [dataTestId]="'file-name-autocomplete'">
    </dynamic-autocomplete>

    <mat-form-field>
      <mat-label>Arrival date from</mat-label>
      <input
        matInput
        readonly
        [matDatepicker]="picker"
        formControlName="ArrivalDateFrom"
      />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker #picker />
      @if (showArrivalDateFromClearIcon) {
      <button
        matSuffix
        mat-icon-button
        (click)="resetFilter('ArrivalDateFrom')"
      >
        <mat-icon fontIcon="close"></mat-icon>
      </button>
      } @else {
      <mat-datepicker-toggle matIconSuffix [for]="picker" />
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Arrival date to</mat-label>
      <input
        matInput
        readonly
        [matDatepicker]="picker2"
        formControlName="ArrivalDateTo"
      />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker #picker2 />
      @if (showArrivalDateToClearIcon) {
      <button matSuffix mat-icon-button (click)="resetFilter('ArrivalDateTo')">
        <mat-icon fontIcon="close"></mat-icon>
      </button>
      } @else {
      <mat-datepicker-toggle matIconSuffix [for]="picker2" />
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Departure date from</mat-label>
      <input
        matInput
        readonly
        [matDatepicker]="picker3"
        formControlName="DepartureDateFrom"
      />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker #picker3 />
      @if (showDepartureDateFromClearIcon) {
      <button
        matSuffix
        mat-icon-button
        (click)="resetFilter('DepartureDateFrom')"
      >
        <mat-icon fontIcon="close"></mat-icon>
      </button>
      } @else {
      <mat-datepicker-toggle matIconSuffix [for]="picker3" />
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Departure date to</mat-label>
      <input
        matInput
        readonly
        [matDatepicker]="picker4"
        formControlName="DepartureDateTo"
      />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker #picker4 />
      @if (showDepartureDateToClearIcon) {
      <button
        matSuffix
        mat-icon-button
        (click)="resetFilter('DepartureDateTo')"
      >
        <mat-icon fontIcon="close"></mat-icon>
      </button>
      } @else {
      <mat-datepicker-toggle matIconSuffix [for]="picker4" />
      }
    </mat-form-field>
    <dynamic-autocomplete
        formControlName="HotelConfirmationNumber"
        [formLabel]="'Confirmation Number'"
        [tableName]="'CommissionReconciliation'"
        [columnName]="'HotelConfirmationNumber'"
        [emitString]="true"
        [dataTestId]="'confirmation-number-autocomplete'">
    </dynamic-autocomplete>
    <dynamic-autocomplete
        formControlName="AdxTripReference"
        [formLabel]="'Adx Reference'"
        [tableName]="'Trip'"
        [columnName]="'ExternalReference'"
        [emitString]="true"
        [dataTestId]="'adx-reference-autocomplete'">
    </dynamic-autocomplete>
  </form>
</mat-dialog-content>

<mat-divider />

<mat-dialog-actions class="modal-panel-secondary__footer">
  <button mat-stroked-button color="primary" (click)="reset()">
    Clear All
    <mat-icon>delete_outline</mat-icon>
  </button>
  <button mat-raised-button color="primary" (click)="apply()">Apply</button>
</mat-dialog-actions>
